<template>
  <div>
    <a-table
      bordered
      :data-source="dataTable"
      :columns="columns"
      size="small"
      :scroll="{ x: 1200, y: 500 }"
    >
      <template slot="frequently" slot-scope="text, record">
        <editable-select-cell
          text="jack"
          @change="onCellChange(record.key, 'frequently', $event)"
        />
      </template>
      <template slot="formula" slot-scope="text, record">
        <editable-select-cell
          text="jack"
          @change="onCellChange(record.key, 'formula', $event)"
        />
      </template>
      <template slot="weight" slot-scope="text, record">
        <editable-input-cell
          text="0"
          type="number"
          @change="onCellChange(record.key, 'weight', $event)"
        />
      </template>
      <template slot="uom" slot-scope="text, record">
        <editable-input-cell
          text="jack"
          type="text"
          @change="onCellChange(record.key, 'uom', $event)"
        />
      </template>
      <template slot="target" slot-scope="text, record">
        <editable-input-cell
          text="0"
          type="number"
          @change="onCellChange(record.key, 'target', $event)"
        />
      </template>
      <template slot="actual" slot-scope="text, record">
        <editable-input-cell
          text="0"
          type="number"
          @change="onCellChange(record.key, 'actual', $event)"
        />
      </template>
    </a-table>
  </div>
</template>
<script>
import EditableSelect from '@/components/Table/EditableSelect.vue';
import EditableInput from '@/components/Table/EditableInput.vue';
export default {
  name:'TableCreate',
  components: {
    EditableSelectCell:EditableSelect,
    EditableInputCell:EditableInput
  },
  props:{
    columns: Array,
    dataTable: Array,
    key: String
  },
  data() {
    return {
      count: 1,
    };
  },
  onMounted(){
    console.log(this.columns)
  }
  ,
  methods: {
    onCellChange(key, dataIndex, value) {
      const dataSource = [...this.dataSource];
      const target = dataSource.find(item => item.key === key);
      if (target) {
        target[dataIndex] = value;
        this.dataSource = dataSource;
      }
    },
  }
};
</script>
<style lang="less" scoped>
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>
